var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showHeader
    ? _c(
        "b-row",
        { staticClass: "content-header no-print" },
        [
          _c(
            "b-col",
            {
              staticClass: "content-header-left mb-2",
              attrs: { cols: "12", md: "9" }
            },
            [
              _c(
                "b-row",
                { staticClass: "breadcrumbs-top" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "h2",
                      {
                        staticClass: "content-header-title float-left pr-1 mb-0"
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.translate(_vm.headingTitle)) + " "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "breadcrumb-wrapper" },
                      [
                        _c(
                          "b-breadcrumb",
                          [
                            _c(
                              "b-breadcrumb-item",
                              { attrs: { to: "/" } },
                              [
                                _c("feather-icon", {
                                  staticClass: "align-text-top",
                                  attrs: { icon: "HomeIcon", size: "16" }
                                })
                              ],
                              1
                            ),
                            _vm._l(_vm.normalizedBreadcrumb, function(
                              item,
                              index
                            ) {
                              return _c(
                                "b-breadcrumb-item",
                                {
                                  key: "bc-" + index + "-" + item.label,
                                  attrs: {
                                    active: item.active === true,
                                    to: item.active ? undefined : item.linkTo
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.translate(item.label)) +
                                      " "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }